<svg (mouseenter)="mouseEnter()"
     (mouseleave)="mouseLeave()"
     [attr.height]="height"
     [attr.width]="width"
     [class.cursor-pointer]="isButton"
     fill="none"
     viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
  <path [attr.stroke]="color" d="M5 0V10M10 5L0 5" stroke-width="2"/>
</svg>
